export const handleLoginError = ({ error, actions }) => {
    const { error_code, message, resolution } = error || {};

    const {
        showMFAModal,
        hideMFAModal,
        mfaFailedToVerify,
        setupMFA,
        credentialsExpired,
        invalidCredentials,
        externalAuthEnabled,
        accountLocked,
        defaultAction,
    } = actions;

    const handlers = {
        mfa_token_required: () => showMFAModal(),

        mfa_token_expired_or_invalid: () => mfaFailedToVerify(),

        mfa_failed_to_verify: () => mfaFailedToVerify(),

        mfa_enrollment_required: () => setupMFA(),

        credentials_expired: () => credentialsExpired(),

        invalid_credentials: () => invalidCredentials(),

        external_authentication_enabled: () => externalAuthEnabled(),

        user_account_locked: () => accountLocked(),

        default: () => defaultAction(),
    };

    const handler = handlers[error_code] || handlers.default;
    handler();
};
